module.exports = __webpack_public_path__ + "img/client.dbe7a13e.svg";